import { PartnerButton, ButtonAlignment } from '@fitscovery/partner/data-access';

export class UtilCustomButtonAlignment {

    public static setButtonAlignment(button: PartnerButton): string | undefined {

        if (button?.alignment === ButtonAlignment.Center) {
            return 'justify-content-center';
        } else if (
            button?.alignment === ButtonAlignment.Left
        ) {
            return 'justify-content-start';
        } else if (
            button?.alignment === ButtonAlignment.Right
        ) {
            return 'justify-content-end';
        }
    }
}
